import { render, staticRenderFns } from "./classStatistics.vue?vue&type=template&id=422a6301&scoped=true"
import script from "./classStatistics.vue?vue&type=script&lang=js"
export * from "./classStatistics.vue?vue&type=script&lang=js"
import style0 from "./classStatistics.vue?vue&type=style&index=0&id=422a6301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a6301",
  null
  
)

export default component.exports